import SegPWidget from './lib/components/SegPWidget/index.jsx';
import SegPInsights, {
  SegmentTypes,
} from './lib/components/SegPInsights/index.jsx';

export { SegPWidget, SegPInsights, SegmentTypes };

export default SegPWidget;
